import { getSession } from "./skill";

export const getWorkers = () => async (dispatch, getState) => {
  let results = await dispatch(getSession());
  var worker = getState().skillReducer.devices;
  let allDeviceData = [];
  await worker.map((w) => {
    let worker_id = w.id;
    let worker_type = "standard";
    let queue_name = w.id;
    let worker_name = w.session_name;
    allDeviceData.push({ worker_id, worker_type, queue_name, worker_name });
  });
  return allDeviceData;
};
